var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lds"},[_c('div',{staticClass:"lds-facebook"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')])])}]

export { render, staticRenderFns }